import React, { Suspense, useEffect, useState } from 'react';
import { Spin } from 'antd';
import { BASE_URL } from "../Components/Constant";
import PluginLoader from "../Components/PluginLoader";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error rendering component:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <div>Something went wrong while loading the component.</div>;
    }
    return this.props.children; 
  }
}

const RenderCustomComponent = ({ component ,recordId,objectName}) => {
  console.log("RenderCustomComponent received:", component);
  console.log("Component Name:", component.selectedComponentName);

  const [plugins, setPlugins] = useState([]);
  const [loading, setLoading] = useState(true);   
  const [error, setError] = useState(null);       

  useEffect(() => {
    // if (!component.selectedComponentName) return;
    console.log("Fetching Custom plugin for:", component.selectedComponentName);
    const fetchPlugins = async () => {
      setLoading(true);
      setError(null);

      try {
        const res = await fetch(
          `${BASE_URL}/plugins/retrieve?name=${component.selectedComponentName}`
        );

        if (!res.ok) throw new Error("Failed to fetch plugin");

        const data = await res.json();
        setPlugins(Array.isArray(data) ? data : [data]);
      } catch (err) {
        console.error("Failed to load plugins", err);
        setPlugins([]);
        setError(err.message || "Unknown error");
      } finally {
        setLoading(false);
      }
    };

    fetchPlugins();
  }, [component.selectedComponentName]); // ONLY run when name changes

  //Loading UI
  if (loading) {
    return (
      <div style={{ padding: "20px", textAlign: "center" }}>
        <Spin size="large" />
        <div style={{ marginTop: 8 }}>Loading plugin…</div>
      </div>
    );
  }

  //Friendly error UI
  if (error) {
    return (
      <div style={{ padding: "20px", color: "red", textAlign: "center" }}>
        Failed to load plugin: {error}
      </div>
    );
  }

  //No plugin found
  if (!plugins.length) {
    return (
      <div style={{ padding: "20px", textAlign: "center" }}>
        No plugin found for <strong>{component.selectedComponentName}</strong>
      </div>
    );
  }

  return (
    <ErrorBoundary>
      <Suspense fallback={<Spin size="large" />}>
        {plugins.map((plugin) => (
          <PluginLoader 
            manifest={plugin} 
            key={plugin.name}
            propsFromHost={{ recordId: recordId }}
            objectData={{ mode: "detail", objectName: objectName,recordId: recordId }}
          />
        ))}
      </Suspense>
    </ErrorBoundary>
  );
};

export default RenderCustomComponent;